<template>
  <div>
    <div class="container">
      <loading-wrap :loading="loading">
        <div v-if="error" class="alert alert-danger mt-4">
          Assessment completed or expired. Please contact Personal Tutors on
          1300 360 245 for further assistance.
        </div>
        <div v-if="assessment" class="py-5">
          <h2>
            Report for {{ assessment.firstName }} {{ assessment.lastName }}
          </h2>
          <hr />
          <div v-if="!success">
            <div v-for="(q, i) in assessment.questions">
              <h4>
                {{ q.order + 1 }} {{ q.question ? ": " + q.question : "" }}
              </h4>
              <selector-card
                v-model="assessment.questions[i].answer"
                :options="q.tutorSentences.slice().reverse()"
              />
              <hr />
            </div>
            <label>Additional Comments<span class="text-danger">*</span></label>
            <textarea
              class="form-control"
              v-model="assessment.comments"
              required
            ></textarea>
            <hr />
            <hr />
            <div class="alert alert-danger mb-2">
              <b>NOTE:</b> You will not be able to ammend your report following
              submission. Please ensure this report contains all necessary
              information in order to be reviewed by management.
            </div>
            <div class="d-flex justify-content-end">
              <button
                type="button"
                @click="submit"
                class="btn btn-success"
                :disabled="formLoading"
              >
                <svg-loader />
                <span>Submit</span>
              </button>
            </div>
          </div>
          <hr v-if="success" />
          <div class="alert alert-success" v-if="success">
            Submission successfully saved.
          </div>
        </div>
      </loading-wrap>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      loading: true,
      assessment: null,
      error: null,
      formLoading: false,
      success: null,
      loadsRequired: 0,
      fileUploading: false,
    };
  },
  methods: {
    submit() {
      if (this.assessment && this.assessment.questions) {
        const hasUnanswered = this.assessment.questions.some(
          (q) => q.answer === undefined
        );

        if (hasUnanswered === true) {
          return window.alert(
            "Please answer all questions before submitting this form."
          );
        }
      }

      if (!this.assessment.comments || !this.assessment.comments.trim()) {
        return window.alert(
          "Please enter additional comments before submitting."
        );
      }

      this.formLoading = true;
      this.success = false;

      this.axios
        .patch(
          `${process.env.VUE_APP_API_URL}/api/assessments/${this.id}?tutor=true`,
          this.assessment
        )
        .then((res) => {
          this.success = true;
        })
        .finally(() => {
          this.formLoading = false;
        });
    },
    remove(index) {
      this.assessment.attachments = [
        ...this.assessment.attachments.slice(0, index),
        ...this.assessment.attachments.slice(
          index + 1,
          this.assessment.attachments.length
        ),
      ];
    },
    upload({ target: { files } }) {
      this.fileUploading = true;
      this.loadsRequired = files.length;

      const config = {
        headers: {
          "Content-Type": undefined,
        },
      };

      for (const file of files) {
        const formData = new FormData();

        formData.append("file", file);

        this.axios
          .post(
            `${process.env.VUE_APP_API_URL}/api/templates/uploads`,
            formData,
            config
          )
          .then((res) => {
            this.assessment.attachments.push(res.data);
          })
          .finally(() => {
            this.loadsRequired--;

            if (this.loadsRequired === 0) {
              this.fileUploading = false;
            }
          });
      }

      this.$refs.file.value = null;
    },
  },
  created() {
    this.axios
      .get(
        `${process.env.VUE_APP_API_URL}/api/assessments/${this.id}?tutor=true`
      )
      .then((res) => {
        this.assessment = res.data;
        this.assessment.attachments = [];
      })
      .catch(() => {
        this.error = true;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>
